import axios from 'axios'
import { CONNECTION_TIMEOUT } from '../../../config'

export const trustedShopsQuestionnaireLink = async (transactionId: string) => {
  const url = `${process.env.REACT_APP_API_GATEWAY}/trusted-shops/${transactionId}`
  const response = await axios.post(url, null, {
    timeout: CONNECTION_TIMEOUT,
    validateStatus: (statusCode) => statusCode === 200,
  })
  return response?.data?.redirectUrl || ''
}
